import { ReactElement, useEffect, useRef } from 'react';
import { useVerifyEmailAction } from '../actions';
import {
    UIButton,
    UIInlineAlert,
    UILoadingState,
    UISpacer,
    UIText
} from '@/ui';
import styles from './verify-email.module.scss';
import { useNavigate } from 'react-router';
import { useMeTranslation } from '../hooks';

type VerifyEmailProps = {
    token: string;
};
export function VerifyEmail(props: VerifyEmailProps): ReactElement {
    const { token } = props;

    const navigate = useNavigate();

    const { t } = useMeTranslation();

    const { verifyEmail, loading, error } = useVerifyEmailAction();
    const hasRun = useRef(false);
    useEffect(() => {
        if (!hasRun.current) {
            hasRun.current = true;
            verifyEmail({ token }).catch(() => {}); // Handled in hook
        }
    }, [verifyEmail, token]);

    if (error && !loading) {
        return (
            <div className={styles.container}>
                <UIInlineAlert text={error} />
            </div>
        );
    }

    if (loading) {
        return (
            <div className={styles.container}>
                <UILoadingState text={t('components.verify_email.loading')} />
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center'
                }}
            >
                <UIText>{t('components.verify_email.success')}</UIText>
            </div>
            <UISpacer multiplier={2} />
            <UIButton
                onClick={() => {
                    void navigate('/');
                }}
            >
                {t('shared.labels.continue')}
            </UIButton>
        </div>
    );
}
